import { ARTIST, Artist } from '@favid-inc/api';
// import { Get, OrderByElement, Put, WhereElement } from '@favid-inc/api/lib/rest';
import { OrderByElement, Put } from '@favid-inc/api/lib/rest';
import { Action, Filter } from 'core/generic';
import { MESSAGE_ERROR } from 'core/redux/types';
import { request as client } from 'utils';
import { registerMessage } from 'utils/message';
import { BEFORE_PROCESSING, ON_FETCH_ARTISTS, ON_UPDATE_ARTIST, ROLLBACK_INITIAL_STATE } from './types';

export const getArtistsByFilter = async (filter: Filter) => {
  try {
    const request = {
      url: `/${ARTIST}`,
      method: 'GET' as 'GET',
      params: {
        limit: filter.itensPerPage,
        offset: filter.page,
        where: filter.where,
        orderBy: [
          {
            attr: 'name',
            exp: 'ASC',
          },
        ] as OrderByElement[],
      },
    };

    const response = await client.request(request);
    return response.data;
  } catch (error) {
    registerMessage({ description: 'Ocorreu um erro ao consultar os artistas', type: MESSAGE_ERROR });
  }
};

export const fetchArtists = async (filter: Filter, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });

  try {
    const payload = await getArtistsByFilter(filter);
    dispatch({
      type: ON_FETCH_ARTISTS,
      payload,
    });
  } catch (error) {
    dispatch({
      type: ROLLBACK_INITIAL_STATE,
    });
  }
};

export const updateArtist = async (artist: Artist, callback: (action: Action) => void) => {
  callback({
    type: BEFORE_PROCESSING,
  });

  try {
    const request: Put<Artist>['Request'] = {
      url: `/${ARTIST}/${artist.id}`,
      method: 'PUT',
      data: artist,
    };

    const response = await client.request<Put<Artist>['Response']>(request);

    callback({
      type: ON_UPDATE_ARTIST,
      payload: response.data,
    });
  } catch (error) {
    callback({
      type: ROLLBACK_INITIAL_STATE,
    });
  }
};

export const fetchAllArtists = async () => {
  const filter: Filter = {
    itensPerPage: 50,
    page: 0,
  };
  let list: Artist[] = [];
  let total = 0;
  do {
    const response = await getArtistsByFilter(filter);
    list = [...list, ...response.list];
    total = response.total;
  } while (list.length < total);
  return list;
};
